import * as React from 'react';
import { useGetStepsTabs } from '@/scopes/checkout/domain/hooks';
import { tk, Typography } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints';
import { Steps } from '@/scopes/checkout/components/Steps';

const Wrapper = styled.div`
  margin-top: ${tk('spacing_xl')};
`;

export function CheckoutProgress() {
  const { isLoading, activeStep, items } = useGetStepsTabs();
  const { isDesktopSm } = useBreakpoints();

  if (isLoading) return '';

  return (
    <Wrapper data-qa="checkout-progress">
      <Steps activeStepValue={activeStep}>
        {items.map((step, index) => (
          <Steps.Step key={index} disabled={step.disabled} value={step.text} completed={step.completed}>
            {isDesktopSm && <StepText $variant="body-xs">{step.text}</StepText>}
          </Steps.Step>
        ))}
      </Steps>
    </Wrapper>
  );
}

const StepText = styled(Typography)`
  text-align: center;
`;
